import React from 'react';
import PropTypes from 'prop-types';
import { Image, isEditorActive, Link, Text } from '@sitecore-jss/sitecore-jss-react';
import { connect } from 'react-redux';
import ReplaceableRichText from '../../../utils/text/ReplaceableRichText';

const getCTAs = fields => {
  return (
    (isEditorActive() || fields.primaryCta?.value?.text || fields.secondaryCta?.value?.text) && (
      <div className="vds-super-hero__action">
        {fields.primaryCta?.value?.text && (
          <Link
            className="vds-button"
            field={fields.primaryCta}
            data-testid={`${fields.testid?.value}-primary-cta`}
          >
            {fields.primaryIcon?.value && (
              <>
                <i className={`fa-solid fa-${fields.primaryIcon?.value}`} />
                {fields.primaryCta?.value?.text}
              </>
            )}
          </Link>
        )}

        {fields.secondaryCta?.value?.text && (
          <Link field={fields.secondaryCta} data-testid={`${fields.testid?.value}-secondary-cta`} />
        )}
      </div>
    )
  );
};

const resolveFields = (fields, showPrincipalAgeError) => {
  if (!showPrincipalAgeError) {
    return fields;
  }
  return {
    ...fields,
    heading: fields.principalAgeHeading?.value ? fields.principalAgeHeading : fields.heading,
    content: fields.principalAgeContent?.value ? fields.principalAgeContent : fields.content,
  };
};

const SuperHero = ({ fields, params, showPrincipalAgeError }) => {
  const variant = params.variant || 'white';
  const resolved = resolveFields(fields, showPrincipalAgeError);
  return (
    <div className="vds-page-container__section vds-page-container__section--white-bg">
      <div className={`vds-super-hero vds-super-hero--${variant} vds-margin-bottom-spacing-0`}>
        <div className="vds-super-hero__inner">
          <div className="vds-super-hero__content">
            <Text
              tag="h2"
              className="vds-super-hero__heading"
              field={resolved.heading}
              data-testid={`${fields.testid?.value}-heading`}
            />
            <ReplaceableRichText
              className="vds-margin-bottom-spacing-5"
              field={resolved.content}
              data-testid={`${fields.testid?.value}-content`}
              isCurrency="false"
            />
            {fields.disclaimer?.value && (
              <Text
                tag="p"
                className="vds-super-hero__disclaimer"
                field={fields.disclaimer}
                data-testid={`${fields.testid?.value}-disclaimer`}
              />
            )}
          </div>
          {isEditorActive() && (
            <Image
              className="vds-super-hero__image"
              field={fields.image}
              data-testid={`${fields.testid?.value}-image`}
            />
          )}
          {!isEditorActive() && fields.image?.value?.src && (
            <div
              className="vds-super-hero__image"
              style={{ backgroundImage: `url("${fields.image?.value?.src}")` }}
              data-testid={`${fields.testid?.value}-background-image`}
            />
          )}
          {!showPrincipalAgeError && getCTAs(fields)}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  showPrincipalAgeError: !!state.appState?.quoteRevalidation?.principalAgeInvalid,
});

const fieldsPropType = PropTypes.shape({
  testid: PropTypes.shape({ value: PropTypes.string }),
  heading: PropTypes.shape({ value: PropTypes.string }),
  content: PropTypes.shape({ value: PropTypes.string }),
  disclaimer: PropTypes.shape({ value: PropTypes.string }),
  image: PropTypes.shape({
    value: PropTypes.shape({ src: PropTypes.string }),
  }),
  primaryCta: PropTypes.shape({
    value: PropTypes.shape({ text: PropTypes.string }),
  }),
  secondaryCta: PropTypes.shape({
    value: PropTypes.shape({ text: PropTypes.string }),
  }),
  primaryIcon: PropTypes.shape({ value: PropTypes.string }),
  principalAgeHeading: PropTypes.shape({ value: PropTypes.string }),
  principalAgeContent: PropTypes.shape({ value: PropTypes.string }),
});

SuperHero.propTypes = {
  fields: fieldsPropType,
  params: PropTypes.shape({
    variant: PropTypes.string,
  }),
  showPrincipalAgeError: PropTypes.bool,
};

export default connect(mapStateToProps)(SuperHero);
